export enum PageType {
  CONTENT,
  REDIRECT,
}
export const PageTypeValues = {
  [PageType.CONTENT]: "Content page",
  [PageType.REDIRECT]: "Redirect url",
};
